import React from 'react';
import Immutable from 'immutable';
import {Provider} from 'react-redux';
import {configureStore} from '../config/';
import reducers from './module';
import Reviews from './Reviews';

const Index = ({initialState, pageScope}) => {
    initialState = Immutable.fromJS(initialState) || {};

    const store = configureStore(initialState, reducers);

    return (
        <Provider store={store}>
            <Reviews ps={pageScope}/>
        </Provider>
    );
};

export default Index;


// WEBPACK FOOTER //
// ./src/reviews/index.js